
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecabserviceinambatturchennai() {



    const cardData =
    {
        keyword: ' Corporate Cab Service in Ambattur Chennai',
        heading: 'etravo : Corporate Cab Service in Ambattur Chennai',



"headingDescription": "eTravo offers reliable Corporate Cab Services in Ambattur Chennai, designed for industrial units, IT companies, and corporate offices that require seamless transportation for employee commuting, shift-based pickup and drop, airport transfers, and executive travel. With GPS-enabled vehicles, experienced chauffeurs, and flexible corporate plans, eTravo ensures safe, punctual, and efficient mobility across Ambattur and nearby business zones.",

"top": "Top Corporate Cab Service Areas in Ambattur Chennai with eTravo",

"topPlaces": [
  {
    "title": "Ambattur Industrial Estate",
    "description": "One of Chennai’s largest industrial hubs with manufacturing units and factories requiring large-scale employee transportation and shift-based cab services."
  },
  {
    "title": "SIDCO Industrial Estate Ambattur",
    "description": "A major cluster of small and medium industries requiring structured workforce mobility and daily pickup and drop services."
  },
  {
    "title": "Mogappair",
    "description": "A nearby residential and commercial area supporting employees commuting to Ambattur industrial zones."
  },
  {
    "title": "Padi Industrial Area",
    "description": "A key industrial and commercial belt with factories and offices requiring reliable corporate cab services."
  },
  {
    "title": "Anna Nagar West",
    "description": "A premium residential locality with professionals requiring daily office commute and corporate travel services."
  },
  {
    "title": "Avadi Industrial Zone",
    "description": "A growing industrial hub near Ambattur requiring workforce transportation and shift-based cab services."
  },
  {
    "title": "Korattur",
    "description": "A residential and industrial mix zone supporting daily employee movement to nearby factories and offices."
  },
  {
    "title": "Red Hills Logistics Corridor",
    "description": "A major transport and logistics route connecting industrial hubs requiring efficient corporate mobility solutions."
  },
  {
    "title": "Chennai Bypass Road Corridor",
    "description": "A key connectivity route used for employee transport and intercity corporate travel."
  },
  {
    "title": "Ambattur to Chennai Airport Route",
    "description": "A critical travel corridor for executive airport transfers and corporate business travel."
  }
],


"services": [
{
"name": "Corporate Cab Ambattur Chennai",
"description": "eTravo offers reliable corporate cab services in Ambattur Chennai designed for smooth and professional business travel. Our service ensures punctual pickups, comfortable rides, and experienced chauffeurs for daily office commuting and executive travel."
},
{
"name": "Taxi Ambattur Chennai",
"description": "Our taxi services in Ambattur Chennai provide quick and dependable transportation for professionals and employees. eTravo ensures clean vehicles, timely service, and a hassle-free travel experience across industrial and residential areas."
},
{
"name": "Company Cab Ambattur",
"description": "eTravo provides company cab services in Ambattur tailored for corporate and industrial needs. From employee transport to executive travel, our service ensures reliability, safety, and smooth operations."
},
{
"name": "Office Transport Ambattur Chennai",
"description": "Simplify employee commuting with eTravo’s office transport services in Ambattur Chennai. We offer structured and efficient transportation solutions for daily travel across offices and factories."
},
{
"name": "Employee Cab Ambattur",
"description": "Our employee cab services in Ambattur are designed for safe and punctual commuting. eTravo ensures well-coordinated pickup and drop services for smooth daily travel."
},
{
"name": "Corporate Travel Ambattur Chennai",
"description": "eTravo offers corporate travel services in Ambattur Chennai for both local and outstation business needs. Our service ensures reliable and comfortable journeys for executives and teams."
},
{
"name": "Business Cab Ambattur",
"description": "eTravo’s business cab services in Ambattur are ideal for meetings, client visits, and corporate activities. Our service focuses on punctuality and professional travel experiences."
},
{
"name": "Staff Transport Ambattur Chennai",
"description": "eTravo provides dependable staff transport services in Ambattur Chennai for daily employee commuting. Our service ensures timely pickups, safe rides, and efficient coordination."
},
{
"name": "Corporate Taxi Ambattur",
"description": "Our corporate taxi services in Ambattur offer flexible and reliable transportation for businesses. eTravo ensures smooth travel for employees, executives, and corporate clients."
},
{
"name": "Company Taxi Ambattur Chennai",
"description": "eTravo’s company taxi services in Ambattur Chennai provide convenient travel solutions for corporate requirements. Our taxis are ideal for daily operations and client handling."
},
{
"name": "Corporate Pickup Drop Ambattur",
"description": "eTravo offers corporate pickup and drop services in Ambattur for efficient employee commuting. Our service ensures punctual scheduling and comfortable travel experiences."
},
{
"name": "Office Cab Booking Ambattur",
"description": "Book office cabs in Ambattur easily with eTravo. Our reliable service ensures timely pickups, comfortable rides, and hassle-free travel for corporate teams."
},
{
"name": "Business Travel Cab Ambattur",
"description": "Our business travel cab services in Ambattur are designed for professionals traveling for meetings and corporate tasks. eTravo ensures smooth and efficient journeys."
},
{
"name": "Corporate Commute Ambattur Chennai",
"description": "eTravo’s corporate commute services in Ambattur Chennai provide structured and dependable employee transportation. Our service ensures smooth daily travel for corporate staff."
},
{
"name": "Professional Cab Ambattur",
"description": "eTravo offers professional cab services in Ambattur with trained drivers and well-maintained vehicles. Our service ensures safe, comfortable, and reliable travel for all business needs."
}
],
"tableData": [
["Corporate Cab Ambattur Chennai", "Taxi Ambattur Chennai"],
["Company Cab Ambattur", "Office Transport Ambattur Chennai"],
["Employee Cab Ambattur", "Corporate Travel Ambattur Chennai"],
["Business Cab Ambattur", "Staff Transport Ambattur Chennai"],
["Corporate Taxi Ambattur", "Company Taxi Ambattur Chennai"],
["Corporate Pickup Drop Ambattur", "Office Cab Booking Ambattur"],
["Business Travel Cab Ambattur", "Corporate Commute Ambattur Chennai"],
["Professional Cab Ambattur", ""]
],



"whychoose": [
    {
      "WhyChooseheading": "Reliable Corporate Cab Service in Ambattur Chennai",
      "WhyChoosedescription": "eTravo offers dependable corporate cab services in Ambattur Chennai, ensuring smooth and efficient employee transportation for industrial units, IT parks, and business establishments."
    },
    {
      "WhyChooseheading": "Ideal for Ambattur Industrial Estate and Business Zones",
      "WhyChoosedescription": "Ambattur is one of Chennai’s major industrial corridors with manufacturing units and corporate offices, making structured employee transport essential for workforce mobility."
    },
    {
      "WhyChooseheading": "Daily Employee Pickup and Drop Services",
      "WhyChoosedescription": "Corporate cab services provide organized daily pickup and drop with route optimization, helping employees reach workplaces on time and improving operational efficiency. :contentReference[oaicite:0]{index=0}"
    },
    {
      "WhyChooseheading": "Flexible Shift-Based Transportation Solutions",
      "WhyChoosedescription": "Industrial and corporate operations in Ambattur often run in multiple shifts, and cab services ensure safe and timely transport for day, night, and rotational shifts. :contentReference[oaicite:1]{index=1}"
    },
    {
      "WhyChooseheading": "Wide Fleet for Workforce and Corporate Travel",
      "WhyChoosedescription": "We provide hatchbacks, sedans, SUVs, and larger vehicles suitable for employee commute, management travel, and group transportation needs."
    },
    {
      "WhyChooseheading": "Technology-Driven Fleet and Real-Time Tracking",
      "WhyChoosedescription": "Modern corporate cab services use GPS tracking, centralized monitoring, and smart routing systems to ensure safety, efficiency, and transparency in employee transport. :contentReference[oaicite:2]{index=2}"
    },
    {
      "WhyChooseheading": "Professional Chauffeurs with Local Expertise",
      "WhyChoosedescription": "Experienced drivers familiar with Ambattur Industrial Estate and surrounding areas ensure safe, punctual, and efficient travel for employees."
    },
    {
      "WhyChooseheading": "24/7 Support for Corporate and Industrial Operations",
      "WhyChoosedescription": "Round-the-clock support ensures smooth coordination for shift-based transport, urgent travel needs, and uninterrupted business operations. :contentReference[oaicite:3]{index=3}"
    }
  ]

}

const faqData = [
    [
        {
            question: 'What is corporate cab service in Ambattur Chennai?',
            answer: 'Corporate cab service in Ambattur Chennai provides organized transportation for employees working in industrial and business areas including daily commute and shift-based travel.',
        },
        {
            question: 'Why are corporate cab services important in Ambattur?',
            answer: 'Ambattur is a major industrial hub, and reliable transportation ensures employees reach workplaces on time, improving productivity.',
        },
        {
            question: 'Do corporate cab services provide daily pickup and drop?',
            answer: 'Yes, services include structured daily pickup and drop with optimized routes and schedules. :contentReference[oaicite:4]{index=4}',
        },
        {
            question: 'Can transportation be arranged for multiple shifts?',
            answer: 'Yes, corporate cab services support day, night, and rotational shifts for industrial and corporate employees. :contentReference[oaicite:5]{index=5}',
        },
        {
            question: 'What types of vehicles are available for corporate travel?',
            answer: 'Vehicles include hatchbacks, sedans, SUVs, buses, and larger vehicles depending on workforce size and requirements.',
        },
        {
            question: 'Are corporate cab services safe for employees?',
            answer: 'Yes, services include GPS tracking, verified drivers, and safety protocols ensuring secure travel. :contentReference[oaicite:6]{index=6}',
        },
        {
            question: 'Can corporate travel plans be customized?',
            answer: 'Yes, companies can customize routes, schedules, and rental plans based on employee locations and operational needs.',
        },
        {
            question: 'Are corporate cab services available 24/7 in Ambattur?',
            answer: 'Yes, most providers operate round the clock to support industrial shifts and business travel. :contentReference[oaicite:7]{index=7}',
        },
        {
            question: 'Do corporate cab services provide airport transfers?',
            answer: 'Yes, airport pickup and drop services are available for employees and corporate clients traveling from Ambattur.',
        },
        {
            question: 'How can I book corporate cab service in Ambattur Chennai?',
            answer: 'You can book through the service provider’s website or contact their support team for customized corporate transport solutions.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Karthik Raj',
        designation: 'Plant Manager, Industrial Unit, Ambattur',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo has streamlined our employee transport in Ambattur. Their punctual service and route management are perfect for industrial operations.”',
    },
    {
        name: 'Ms. Priya Menon',
        designation: 'HR Manager, Manufacturing Company, Chennai',
        rating: [1, 1, 1, 1, 1],
        text: '“We rely on eTravo for workforce transportation in Ambattur. Their flexible plans and reliable service ensure smooth daily commuting for our employees.”',
    },
];




    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Service in Ambattur Chennai",
  "image": "https://www.etravo.in/images/keyword/corporate-cab-ambattur-chennai.jpg",
  "description": "Reliable corporate cab services in Ambattur, Chennai by eTravo. Ideal for employee transport, office pickup and drop, business travel, corporate commute, and professional fleet solutions with safe and timely service.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "1250"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2199",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-cab-service-in-ambattur-chennai"
  }
};







    return (
        <div>

<Helmet>
  <title>Corporate Cab Service in Ambattur Chennai | Office & Employee Transport | eTravo</title>
  <meta 
    name="description" 
    content="Book corporate cab service in Ambattur, Chennai with eTravo for employee transport, office pickup and drop, business travel, and corporate commute solutions. Safe and reliable service." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/160.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecabserviceinambatturchennai;